















































































import { Entity } from '@/models';
import { FormulaInput } from '@/modules/formulas/models/formula-input';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Validations } from 'vuelidate-property-decorators';
import { validationMixin } from 'vuelidate';
import { mixins } from 'vue-class-component';
import { decimal, minLength, minValue, required } from 'vuelidate/lib/validators';
import { BvModalEvent } from 'bootstrap-vue';

@Component({})
export default class CustomFormulaConfiguration<T extends Entity> extends mixins(validationMixin) {
	@Prop({ required: true, type: Array })
	public inputs!: FormulaInput[];

	@Prop({ required: true, type: Array })
	public formulaOptions!: { text: string; value: number; disabled: boolean }[];

	@Prop({ required: false, type: Number })
	public selectedFormulaId!: number | null;

	@Emit('onFormulaParametersChanged')
	public onParametersChanged(input: FormulaInput): FormulaInput[] {
		input.valid = input.value != null && input.value.toString().length > 0;
		return this.inputs;
	}

	@Emit('onFormulaChanged')
	public onFormulaChanged(formulaId: number): number {
		return formulaId;
	}

	@Validations()
	private validations() {
		return {
			circumference: {
				required,
				decimal,
				min: minValue(0),
			},
		};
	}

	private circumference?: number | null = 0;
	private radius?: number | null = 0;

	public getInputLabel(formulaInput: FormulaInput): string {
		let label: string = formulaInput.label;
		if (formulaInput.unit !== null) {
			label += ` (${formulaInput.unit})`;
		}
		return label;
	}

	private openCalculateModal() {
		const input = this.inputs.find(input => input.name === 'radius');
		if (!input) return;

		try {
			this.radius = parseFloat(`${input.value}`);
			this.calculateCircumference(this.radius);
		} catch (ex) {}

		this.$bvModal.show('calculateRadius');
	}

	private calculateRadius(input: number) {
		this.radius = input / (2 * Math.PI);
	}

	private calculateCircumference(input: number) {
		this.circumference = input * (2 * Math.PI);
	}

	private copyToFormula(event: BvModalEvent) {
		const input = this.inputs.find(input => input.name === 'radius');
		if (!input) return;

		input.value = `${this.radius}`;
		input.valid = !!input.value;
	}
}
